export enum MemberGroup {
  SuperAdmin = 1,
  Banned = 2,
  Guest = 3,
  Pending = 4,
  Member = 5,
  BlogVideoEditor = 6,
  ExpiredSubscription = 25,
  CGAMember = 91,
  Accounting = 92,
  Coach = 93,
  SubjectMatterExpert = 94,
  Psychometrician = 95,
  Proofreader = 96,
  Analyst = 97,
  AreFailureConsultant = 98,
  SHA1Cleanup = 99,
  BetaTester = 100,
  DemoAccount = 101,
  DemoDataHolder = 102,
}
